import EMPTY_CHART_BAR_BASIC from '@/assets/empty-chart/bar-basic.svg';
import EMPTY_CHART_HORIZONTAL_BAR_BASIC from '@/assets/empty-chart/bar-horizontal-basic.svg';
import EMPTY_CHART_HORIZONTAL_BAR_STACKED from '@/assets/empty-chart/bar-horizontal-stacked.svg';
import EMPTY_CHART_BAR_STACKED from '@/assets/empty-chart/bar-stacked.svg';
import EMPTY_CHART_LINE_BASIC from '@/assets/empty-chart/line-basic.svg';
import EMPTY_CHART_PIE_BASIC from '@/assets/empty-chart/pie-basic.svg';
import EMPTY_CHART_PIE_DOUGHNUT from '@/assets/empty-chart/pie-doughnut.svg';
import type { ChartType, IChartLayer } from '@/version-types';

export const EMPTY_CHART_MAP: Record<ChartType, string> = {
    'bar-basic': EMPTY_CHART_BAR_BASIC,
    'bar-stacked': EMPTY_CHART_BAR_STACKED,
    'bar-horizontal-basic': EMPTY_CHART_HORIZONTAL_BAR_BASIC,
    'bar-horizontal-stacked': EMPTY_CHART_HORIZONTAL_BAR_STACKED,
    'line-basic': EMPTY_CHART_LINE_BASIC,
    'pie-basic': EMPTY_CHART_PIE_BASIC,
    'pie-doughnut': EMPTY_CHART_PIE_DOUGHNUT,
};

export const checkChartIsEmpty = (layer: Pick<IChartLayer, 'data'>) => layer.data.chartData.length === 0;
